<div class="pedidos-container">
  <div class="card">
    <div class="card-header">
      <h4>Pedidos</h4>
    </div>
    <div class="card-body">
      <!-- Filtros -->
      <div class="row mb-4">
        <div class="col-md-3">
          <div class="form-group">
            <label>Data Inicial</label>
            <input type="date" class="form-control" [(ngModel)]="filtroDataInicial">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Data Final</label>
            <input type="date" class="form-control" [(ngModel)]="filtroDataFinal">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Cliente</label>
            <input type="text" class="form-control" [(ngModel)]="filtroCliente" placeholder="Buscar cliente...">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control" [(ngModel)]="filtroStatus">
              <option value="">Todos</option>
              <option value="Em andamento">Em andamento</option>
              <option value="Concluído">Concluído</option>
              <option value="Aguardando pagamento">Aguardando pagamento</option>
              <option value="Em produção">Em produção</option>
              <option value="Entregue">Entregue</option>
            </select>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Número</th>
              <th>Cliente</th>
              <th>Data</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pedido of pedidos | pedidoFilter:filtroDataInicial:filtroDataFinal:filtroCliente:filtroStatus">
              <td>{{pedido.numero}}</td>
              <td>{{pedido.cliente}}</td>
              <td>{{pedido.data | date:'dd/MM/yyyy'}}</td>
              <td>{{pedido.valor | currency:'BRL'}}</td>
              <td>
                <span [ngClass]="{
                  'badge': true,
                  'badge-primary': pedido.status === 'Em andamento',
                  'badge-success': pedido.status === 'Concluído',
                  'badge-warning': pedido.status === 'Aguardando pagamento',
                  'badge-info': pedido.status === 'Em produção',
                  'badge-secondary': pedido.status === 'Entregue'
                }">
                  {{pedido.status}}
                </span>
              </td>
              <td>
                <button class="btn btn-primary btn-sm mr-2">
                  <i class="bi bi-eye"></i> Detalhes
                </button>
                <button class="btn btn-info btn-sm mr-2">
                  <i class="bi bi-pencil"></i> Editar
                </button>
                <button class="btn btn-success btn-sm mr-2">
                  <i class="bi bi-upload"></i> Importar NFE
                </button>
                <button class="btn btn-secondary btn-sm">
                  <i class="bi bi-printer"></i> Impressão
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div> 